import axios from "axios";
import { axiosInstance } from "./AdminServices";

const API_URL = process.env.REACT_APP_API_URL;
const PUBLIC_API_TOKEN =
  process.env.REACT_APP_PUBLIC_API_TOKEN || process.env.REACT_APP_GUEST_PASSWORD;
const PUBLIC_API_HEADERS = PUBLIC_API_TOKEN
  ? { "x-public-token": PUBLIC_API_TOKEN }
  : {};

export async function getEvents(filters = {}) {
  const response = await axiosInstance.get("/event-master/events", {
    params: filters,
  });
  console.log("Fetched events:", response.data);
  return response.data;
}

export async function getPublicEvents(filters = {}) {
  const response = await axios.get(`${API_URL}/event-master/public/events`, {
    params: filters,
    headers: PUBLIC_API_HEADERS,
  });
  return response.data;
}


export async function getEventById(eventID) {
  const response = await axiosInstance.get(`/event-master/events/${eventID}`);
  return response.data;
}

export async function getEventSummary(eventID) {
  const response = await axiosInstance.get(
    `/event-master/events/${eventID}/summary`
  );
  return response.data;
}

export async function createEvent(payload) {
  const response = await axiosInstance.post("/event-master/events", payload);
  return response.data;
}

export async function updateEvent(eventID, payload) {
  const response = await axiosInstance.put(
    `/event-master/events/${eventID}`,
    payload
  );
  return response.data;
}

export async function deleteEvent(eventID) {
  const response = await axiosInstance.delete(`/event-master/events/${eventID}`);
  return response.data;
}

export async function uploadEventBrochure(eventID, file) {
  const formData = new FormData();
  formData.append("brochure", file);
  const response = await axiosInstance.post(
    `/event-master/events/${eventID}/brochure`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
}

export async function getEventRegistrationIds(eventID, gender = "all") {
  const response = await axiosInstance.get(
    `/event-master/events/${eventID}/registration-ids`,
    {
      params: { gender },
    }
  );
  return response.data;
}

export function getBrochureUrl(eventID) {
  return `${process.env.REACT_APP_API_URL}/event-master/brochure/${eventID}`;
}

export function buildGuestRegistrationLink(eventID) {
  const origin = window.location.origin;
  const base = process.env.REACT_APP_BASENAME || "";
  const normalizedBase = base.endsWith("/") ? base.slice(0, -1) : base;
  return `${origin}${normalizedBase}/retreat-registration?id=${eventID}`;
}

export function buildQrImageUrl(value) {
  return `https://api.qrserver.com/v1/create-qr-code/?size=320x320&data=${encodeURIComponent(
    value
  )}`;
}
